import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import { Button } from '@3plearning/react-components';
import { translate } from '../../../helpers/locale-helpers';

import css from './sub-heading-buttons.scss';

/**
 * SUB HEADING BUTTONS
 * UX required for Skill Quests Mastery requires right hand export & download buttons
 * at level lower. Abstract and use in both places.
 * @param isDownloadEnabled: Show Bulk classroom reports button
 * @param isExportEnabled: Show Export button
 * @param isProcessingDownload: Show loading state for download button
 * @param onDownloadReport: Download button click handler
 * @param onExportReportL Export button click handler
 */
const SubHeadingButtons = ({
    isDownloadEnabled,
    isExportEnabled,
    isProcessingDownload,
    onDownloadReport,
    onExportReport,
    forwardedRef
}) => {
    const text = {
        downloadPrepare: translate('Sub Heading Buttons - Prepare Download'),
        bulkExport: translate('Sub Heading Buttons - Bulk Export'),
        exportButton: translate('Sub Heading Buttons - Export Button')
    };

    const getDownloadButtonText = () =>
        isProcessingDownload ? text.downloadPrepare : text.bulkExport;

    const renderButton = (buttonText, clickHandler, isDisabled, className) => (
        <Button
            text={buttonText}
            primary
            type={Button.LOZENGE}
            onClick={clickHandler}
            disabled={isDisabled}
            className={className}
        />
    );

    return (
        <div
            className={css['sub-heading-buttons-container']}
            ref={forwardedRef}
        >
            <div className={css['sub-heading-btn']}>
                {isDownloadEnabled &&
                    renderButton(
                        getDownloadButtonText(),
                        onDownloadReport,
                        isProcessingDownload,
                        css['download-btn']
                    )}
            </div>
            <div className={css['sub-heading-btn']}>
                {isExportEnabled &&
                    renderButton(
                        text.exportButton,
                        onExportReport,
                        false,
                        css['export-btn']
                    )}
            </div>
        </div>
    );
};

SubHeadingButtons.propTypes = {
    isDownloadEnabled: PropTypes.bool,
    isProcessingDownload: PropTypes.bool,
    isExportEnabled: PropTypes.bool,
    onDownloadReport: PropTypes.func,
    onExportReport: PropTypes.func,
    forwardedRef: PropTypes.any
};

export default styleable(css)(SubHeadingButtons);



// WEBPACK FOOTER //
// ./components/sub-heading/sub-heading-buttons/sub-heading-buttons.js